export enum EPageType {
  info = 'info',
  provider = 'provider',
  category = 'category',
  slotTheme = 'slotTheme',
  none = 'none',
}
